export function axIsTypeInt(x) {
    return typeof x === 'number' && ((x | 0) === x);
}
